import settings from './settings'
import paymentMethods from './paymentMethods'
import emails from './emails'
import taxTypes from './taxTypes'
import people from './people'

export default {
  settings,
  paymentMethods,
  emails,
  taxTypes,
  people,
}
